import { IParsedMessage, TMessagesMap } from '../../types/messages';

interface IRemoveMessageFromChatParams {
  messageId: string;
  messagesMap: TMessagesMap;
  chatMessages: IParsedMessage[];
}

/** Удаляет сообщение из чата по id и обновляет индексы в карте сообщений. */
export function removeMessageFromChat({ messageId, messagesMap, chatMessages }: IRemoveMessageFromChatParams) {
  const messageItemToDelete = messagesMap.get(messageId);

  if (!messageItemToDelete) {
    return chatMessages;
  }

  const nextChatMessages = chatMessages.filter(message => message.messageId !== messageId);

  // если сообщение есть в карте, но нет в списке — карту не трогаем
  if (nextChatMessages.length === chatMessages.length) {
    return nextChatMessages;
  }

  // убираем сообщение из списка и заново выставляем индексы в карте
  nextChatMessages.forEach((message, messageIndex) => {
    messagesMap.set(message.messageId, { message, messageIndex });
  });

  messagesMap.delete(messageId);

  return nextChatMessages;
}
